/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Playing_LatecomerInputs */



/**
* | output |
* | --- |
* | "Want to play? The organizer can still add you for the next round — ask at the desk." |
*
* @param {Tournament_Playing_LatecomerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_playing_latecomer = /** @type {((inputs?: Tournament_Playing_LatecomerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Playing_LatecomerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous voulez jouer ? L'organisateur peut encore vous ajouter pour la prochaine ronde — demandez au bureau des inscriptions.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Quiere jugar? El organizador todavía puede añadirle a la próxima ronda — pregunte en el mostrador de inscripciones.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Quer jogar? O organizador ainda pode adicionar você para a próxima rodada — pergunte no balcão de inscrições.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vuoi giocare? L'organizzatore può ancora aggiungerti per il prossimo round — chiedi al banco iscrizioni.")
	return /** @type {LocalizedString} */ ("Want to play? The organizer can still add you for the next round — ask at the desk.")
});